import { createContext, useContext } from 'react'

const RouteContext = createContext()

const ROUTE_TYPE = {
  GLOBAL: 'global route only accesible for global users',
  SETTINGS: 'settings route only accessible for authenticated users',
  ORGANIZATION: 'routes that require to be in the context of an organization',
  PUBLIC: 'public routes (unauthenticated)',
}

function RouteProvider({ type, children }) {
  return <RouteContext.Provider value={type}>{children}</RouteContext.Provider>
}

function useRouteType() {
  const type = useContext(RouteContext)
  return {
    isSettingsRoute: type === ROUTE_TYPE.SETTINGS,
    isGlobalRoute: type === ROUTE_TYPE.GLOBAL,
    isOrganizationRoute: type === ROUTE_TYPE.ORGANIZATION,
    isPublicRoute: type === ROUTE_TYPE.PUBLIC,
    //used to verify if we are in a route that requires an organization context
    isOrganizationContextRoute: [ROUTE_TYPE.ORGANIZATION, ROUTE_TYPE.SETTINGS].includes(type),
  }
}

export { RouteProvider, useRouteType, ROUTE_TYPE }
